import React, { useEffect } from 'react';
import HomeExhibitions from './HomeExhibitions';
import PageSeoHelmet from './PageSeoHelmet';
import { useExhibitions } from './useExhibitions';

/** Full exhibition schedule — linked from the home banner strip. */
export default function ExhibitionsPage() {
  const exhibitions = useExhibitions();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const hasShows = exhibitions.upcoming.length + exhibitions.recent.length > 0;

  return (
    <div className="exhibitions-page">
      <PageSeoHelmet page="exhibitions" />

      {exhibitions.status === 'loading' ? (
        <div className="container store-page__container py-5 text-center text-muted">
          Loading exhibition schedule…
        </div>
      ) : null}

      {exhibitions.status === 'ready' && hasShows ? (
        <HomeExhibitions
          upcoming={exhibitions.upcoming}
          recent={exhibitions.recent}
          status={exhibitions.status}
        />
      ) : null}

      {exhibitions.status === 'ready' && !hasShows ? (
        <div className="container store-page__container py-5 text-center">
          <h1 className="shop-page-title mb-2">Exhibition schedule</h1>
          <p className="text-muted mb-0">No shows scheduled right now. Check back soon or browse our shop online.</p>
        </div>
      ) : null}
    </div>
  );
}
